import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from '../../Subcomponents/Button';
import ProgressCard from '../../Subcomponents/ProgressCard';
import StatusCard from '../../Subcomponents/StatusCard/StatusCard';
import cssClasses from './ConfigureEvent.module.css';
import createLaunchImg from '../../Assets/Images/Common/createLaunch.svg';
import selectTokenImg from '../../Assets/Images/Common/selectToken.svg';
import settingsImg from '../../Assets/Images/Common/settings.svg';
import attendanceConfigurationImg from '../../Assets/Images/Common/attendanceConfiguration.svg';
import Datagrid from '../../Subcomponents/Datagrid';
import { Box, IconButton, LinearProgress, Typography } from '@mui/material';
import { getAllLaunchesByEvent } from '../../Services/Launch';
import { errorTost, successTost } from '../../Services/Toast';
import { uniq } from 'lodash';
import { getEvent, updateEvent } from "../../Services/Event";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import { dismissLoader, presentLoader } from "../../Services/loader";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function ConfigureEvent() {
  const navigate = useNavigate();
  const params = useParams();
  const eventId = params.eventId;
  const dispatch = useDispatch();
  const [event, setEvent] = useState(null)
  const [flag, setFlag] = useState(false)
  const [allLaunches, setAllLaunches] = useState([]);
  const [configureEvent, setConfigureEvent] = useState([]);
  let loggedInUser = useSelector((state) => state.Auth.user);

  const launchColumns = [
    {
      field: 'title',
      headerName: 'Launch Title',
      width: 300,
    },
    {
      field: 'projectName',
      headerName: 'Project',
      width: 300,
      valueFormatter: (params) => params.row?.projectId?.projectName,
    },
    {
      field: 'completedTabs',
      headerName: 'Launch Progress',
      width: 350,
      renderCell: (params) => {
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            width: "100%"
          }}>
            <Box display={"flex"} flexDirection={"row"} gap={"1rem"} width={"100%"}>
              <Box flex={1}><LinearProgress variant="determinate" sx={{ ...progress_sx }} value={(uniq(params.row.completedTabs).length / 6) * 100} /></Box>
              <Typography fontFamily={"Roboto-Regular"} color={"#5F6368"} fontSize={"1.2rem"}>{uniq(params.row.completedTabs).length} out of 6 completed</Typography>
            </Box>
          </div>
        );
      },
    },
    {
      field: 'last_updated_at',
      headerName: 'Last Update',
      width: 250,
    },
    {
      field: 'booking-mis-url',
      headerName: 'Booking MIS URL',
      width: 700,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
          <div style={{display:"flex",gap:"1rem",alignItems:"center"}}>
            <IconButton
              className={cssClasses.copyButton}
              style={{transform: "scale(1.5)"}}
              onClick={() => {
                navigator.clipboard.writeText(`${window.location.origin}/BookingMIS/${event?.title}/${params.row.title}`);
                successTost("Booking MIS url copied successfully!")
              }}>
              <ContentCopyIcon />
            </IconButton>
            <span style={{fontSize:"1.6rem"}}>{`${window.location.origin}/BookingMIS/${event?.title}/${params.row.title}`}</span>
            </div>
          </div>

        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            {JSON.parse(localStorage.getItem('user'))?.roleId?.accessibleTabs?.Event['Configure Event']['Create a launch']['Create Launch']?.isAccessible &&
              <Button
                clicked={() => {
                  navigate(
                    `/home/Event/ConfigureEvent/${eventId}/CreateLaunch?launch=${params.row.launchId}&submenu=Add Launch Title`
                  );
                }}
                btnName={'Edit'}
                style={{
                  borderRadius: '5rem',
                  backgroundColor: '#1570EF',
                  color: '#FFFFFF',
                  fontSize: '1.6rem',
                }}
                padding={'0.5rem 1rem'}
              />
            }
          </div>

        );
      },
    },
  ];

  useEffect(() => {
    let arr = []
    if (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']['Create a launch']?.isAccessible) {
      arr.push({
        title: 'Create a launch',
        totalProgress: 0,
        currentProgress: 0,
        timeline: [
          // { text: 'Add Launch Title' },
          // { text: 'Select Project' },
          // { text: 'Select Sales / Cp' },
          // { text: 'Select Inventory' },
          // { text: 'Update Price' },
        ],
        image: createLaunchImg,
      })
    }
    if (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']?.['Token']?.isAccessible) {
      arr.push({
        title: 'Select Token',
        totalProgress: 4,
        currentProgress: 0,
        timeline: [
          { text: 'Select Token' },
          { text: 'Select Prerequisite' },
          // { text: 'Arrange Token' },
          { text: 'Schedule Token' },
          { text: 'Tag Launch' },
        ],
        image: selectTokenImg,
      })
    }
    if (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']?.['Attendance Configuration']?.isAccessible) {
      arr.push({
        title: 'Attendance Configuration',
        totalProgress: 5,
        currentProgress: 0,
        timeline: [
          { text: 'Select Tokens For Attendance' },
          { text: 'Arrange Token' },
          { text: 'Select Queue Order' },
          { text: 'Select Cp/Sales' },
          { text: 'Change Priority' },
        ],
        image: attendanceConfigurationImg,
      })
    }
    if (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']?.['Settings']?.isAccessible) {
      arr.push({
        title: 'Settings',
        totalProgress: 5,
        currentProgress: 0,
        timeline: [
          { text: 'Live Event Config' },
          { text: 'Live Inventory Display Config' },
          { text: 'Payment Config' },
          { text: 'Preselect Config' },
          { text: 'Site Visit Config' }
        ],
        image: settingsImg,
      })
    }
    setConfigureEvent(arr)
    setFlag(true)
  }, [])

  useEffect(() => {
    if (flag) {
      presentLoader()
      dispatch(action.activeMenu("ConfigureEvent"));
      getAllLaunchesByEvent(eventId).then((resp) => {
        if (configureEvent.length > 0) {
          if (configureEvent[0].title === 'Create a launch') {
            setConfigureEvent((pre) => {
              pre[0].totalProgress = resp.data.length;
              return [...pre]
            })
          }
        }
        let count = 0
        resp.data.forEach((e, index) => {
          e.id = e.launchId;
          e.projectName = e.projectId.projectName;
          e.last_updated_at = new Date(e.last_updated_at).toDateString()
          if (e.completedTabs.length >= 5) {
            count = count + 1
          }
          if (index === resp.data.length - 1) {
            setConfigureEvent((pre) => {
              pre[0].currentProgress = count;
              return [...pre]
            })
          }
        })
        setAllLaunches(resp.data)
        getEvent(eventId).then((resp) => {
          setEvent(resp[0])
          setConfigureEvent((pre) => {
            if (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']?.['Token']?.isAccessible) {
              pre[pre.findIndex((e) => e.title === 'Select Token')].timeline.forEach((ele, index) => {
                if (resp[0].tokenCompletedTabs?.includes(ele.text)) {
                  pre[pre.findIndex((e) => e.title === 'Select Token')].timeline[index].isCompleted = true
                }
              })
              pre[pre.findIndex((e) => e.title === 'Select Token')].currentProgress = resp[0].tokenCompletedTabs ? uniq(resp[0].tokenCompletedTabs).length : 0
            }
            if (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']?.['Attendance Configuration']?.isAccessible) {
              pre[pre.findIndex((e) => e.title === 'Attendance Configuration')].timeline.forEach((ele, index) => {
                if (resp[0].attendanceCompletedTabs?.includes(ele.text)) {
                  pre[pre.findIndex((e) => e.title === 'Attendance Configuration')].timeline[index].isCompleted = true
                }
              })
              pre[pre.findIndex((e) => e.title === 'Attendance Configuration')].currentProgress = resp[0].attendanceCompletedTabs ? uniq(resp[0].attendanceCompletedTabs).length : 0
            }
            if (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']?.['Settings']?.isAccessible) {
              pre[pre.findIndex((e) => e.title === 'Settings')].timeline.forEach((ele, index) => {
                if (resp[0].settingsCompletedTabs?.includes(ele.text)) {
                  pre[pre.findIndex((e) => e.title === 'Settings')].timeline[index].isCompleted = true
                }
              })
              pre[pre.findIndex((e) => e.title === 'Settings')].currentProgress = resp[0].settingsCompletedTabs ? uniq(resp[0].settingsCompletedTabs).length : 0
            }
            return [...pre]
          })
          dismissLoader()
        })
      }).catch((err) => {
        dismissLoader()
        errorTost("Something went wrong! Please try again later")
      })
      //   } else {
      //     dismissLoader()
      //   }
      // } else {
      //   dismissLoader()
      // }
    }
  }, [flag])

  function publishEvent() {
    console.log(allLaunches)
    console.log(event)
    presentLoader()
    if (event.isPublished === true) {
      updateEvent(event.eventId, { isPublished: false }).then((resp) => {
        successTost('Event unpublished successfully')
        console.log(resp)
        setEvent((pre) => { pre.isPublished = false; return { ...pre } })
        dismissLoader()
      })
    } else {
      if (event.tokenCompletedTabs && event.tokenCompletedTabs.length > 0 && event.tokenCompletedTabs.includes('Select Token') && event.tokenCompletedTabs.includes('Schedule Token')) {
        if (allLaunches.length > 0) {
          for (let i = 0; i < allLaunches.length; i++) {
            if (!allLaunches[i].completedTabs.includes('Select Sales') || !allLaunches[i].completedTabs.includes('Select Cp') || !allLaunches[i].completedTabs.includes('Select Inventory')) {
              errorTost("Please complete launch configuration to publish event")
              dismissLoader()
              break;
            } else {
              if (i === allLaunches.length - 1) {
                updateEvent(event.eventId, { isPublished: true }).then((resp) => {
                  successTost('Event published successfully')
                  setEvent((pre) => { pre.isPublished = true; return { ...pre } })
                  dismissLoader()
                })
              }
            }
          }
        } else {
          dismissLoader()
          errorTost("Please create a launch to publish event")
        }
      } else {
        dismissLoader()
        errorTost("Please complete token configuration to publish event")
      }
    }
  }

  return (
    <div className={cssClasses.mainContainer}>
      <div className={cssClasses.header}>
        <div className={cssClasses.titleWrapper}>
          <div className={cssClasses.title} style={{ display: "flex", flexDirection: "column", alignItems: "baseline" }}>
            {/* <p>Configure {event?.title} Event</p> */}
            <p>{event?.title}</p>
          </div>
          {loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']?.['Publish Event']?.isAccessible &&
            <div className={cssClasses.btnWrapper}>
              <Button
                clicked={() => {
                  publishEvent()
                }}
                btnName={event?.isPublished === true ? 'Unpublish' : 'Publish'}
                style={{
                  borderRadius: '0.4rem',
                  backgroundColor: '#1570EF',
                  color: '#FFFFFF',
                  fontSize: '1.6rem',
                }}
                padding={'0.5rem 1rem'}
              />
            </div>
          }
        </div>
      </div>
      <div className={cssClasses.content}>
        {configureEvent.map((ele, index) => (
          <div className={cssClasses.progressCardWrapper}>
            <div className={cssClasses.progressCard}>
              <ProgressCard
                image={ele.image}
                totalProgress={ele.totalProgress}
                currentProgress={ele.currentProgress}
                timeline={ele.timeline}
                cardTitle={ele.title}
              />
            </div>
            {ele.title === 'Create a launch' && (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']['Create a launch']['Create Launch']?.isAccessible) && (
              <div>
                <Button
                  clicked={() => {
                    navigate(
                      `/home/Event/ConfigureEvent/${eventId}/CreateLaunch?submenu=Add Launch Title`
                    );
                  }}
                  btnName={'Create Launch'}
                  style={{
                    borderRadius: '0.4rem',
                    backgroundColor: '#1570EF',
                    color: '#FFFFFF',
                    fontSize: '1.6rem',
                  }}
                  padding={'0.5rem 1rem'}
                />
              </div>
            )
            }
            {ele.title === 'Select Token' && (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']['Token']?.Configure?.isAccessible) && (
              <div>
                <Button clicked={() => { navigate(`/home/Event/ConfigureEvent/${eventId}/SelectTokens?submenu=Repeated Launch`) }} btnName={'Configure'} style={{ borderRadius: "0.4rem", backgroundColor: "#1570EF", color: "#FFFFFF", fontSize: "1.6rem" }} padding={"0.5rem 1rem"} />
              </div>
            )}
            {ele.title === 'Attendance Configuration' && (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']['Attendance Configuration']?.Configure?.isAccessible) && (
              <div>
                <Button clicked={() => { navigate(`/home/Event/ConfigureEvent/${eventId}/attendanceConfiguration?submenu=Select Tokens For Attendance`) }} btnName={'Configure'} style={{ borderRadius: "0.4rem", backgroundColor: "#1570EF", color: "#FFFFFF", fontSize: "1.6rem" }} padding={"0.5rem 1rem"} />
              </div>
            )}
            {ele.title === 'Settings' && (loggedInUser?.roleId?.accessibleTabs?.Event['Configure Event']['Settings']?.Settings?.isAccessible) && (
              <div>
                <Button
                  clicked={() => {
                    navigate(`/home/Event/ConfigureEvent/${eventId}/Settings?submenu=Live Event Config`);
                  }}
                  btnName={"Settings"}
                  style={{
                    borderRadius: "0.4rem",
                    backgroundColor: "#1570EF",
                    color: "#FFFFFF",
                    fontSize: "1.6rem",
                  }}
                  padding={"0.5rem 1rem"}
                />
              </div>
            )}
          </div>
        ))}

        {allLaunches.length > 0 && (
          <div className={cssClasses.summary}>
            <div className={cssClasses.subHeader}>
              <p>Launch Summary</p>
              <div>
                <Button
                  clicked={() => {
                    navigate(
                      `/home/Event/ConfigureEvent/${eventId}/CreateLaunch/`
                    );
                  }}
                  btnName={'Create Launch'}
                  style={{
                    borderRadius: '0.4rem',
                    backgroundColor: '#1570EF',
                    color: '#FFFFFF',
                    fontSize: '1.6rem',
                  }}
                  padding={'0.5rem 1rem'}
                />
              </div>
            </div>
            <div className={cssClasses.grid}>
              <Datagrid
                columns={launchColumns}
                rows={allLaunches}
                hideFooter={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const progress_sx = {
  height: '10px',
  borderRadius: '5px',
  backgroundColor: '#EAECF0',
  '& .MuiLinearProgress-bar': {
    // backgroundColor: "#6941c6",
  },
};
